<script setup lang="ts">
defineProps<{ events: App.Data.EventData[] }>()
</script>

<template>
	<ul v-if="events.length" role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
		<event-item v-for="event in events" :key="event.uuid" :event="event" />
	</ul>
	<p v-else class="text-gray-700">
		{{ t('app.no_events_found') }}
	</p>
</template>
